import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Header from '../general/Header'
import LoginDrawer from '../general/LoginDrawer'
import CheckingTimeLimit from './CheckingTimeLimit'
import TimeOver from './TimeOver'
import { TIME_LIMIT_URL } from '../../client_url_constant'


const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
  description :{
    position: 'relative',
    width:1000,
    height:600,
  }
});


class Login extends Component {
  constructor(props){
    super(props)
    this.state={
      login: false,
      checkedTimeLimit: false,
      expired: false,
      notFound: false,
    }
    this.checkTimeLimit = this.checkTimeLimit.bind(this)
  }

  async checkTimeLimit(token){

        const body = JSON.stringify({
          token
        });
        const method = "POST";
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        };
        const res = await fetch(TIME_LIMIT_URL, {method, headers, body})
        const result = await res.json()
        if (result.error){
          this.setState({
            notFound : true,
          })
          // window.location.href = "https://avinton.com"
        }
        else {
          await this.setState({
            checkedTimeLimit: true,
            expired: result.timeover,
          });
        }
  }


  componentWillMount = () => {
    const params = new URLSearchParams(this.props.location.search);
    //his.props.setKeywordAndOrder(params.get('keyword'), params.get('order'));
    let token = params.get('token')
    this.checkTimeLimit(token)
  };



  render(){
    if (this.state.notFound) {
      return <Redirect to="/accessdenied"/>
    }
    else {
      return (
        <div>

          <Header login={this.state.login} />
          {!this.state.expired && !this.state.checkedTimeLimit? <CheckingTimeLimit /> : null}
          {!this.state.expired && this.state.checkedTimeLimit? <LoginDrawer /> : null}
          {this.state.expired? <TimeOver /> : null}
        </div>
      )
    }
  }
}


Login.propTypes = {
  classes: PropTypes.object.isRequired,
  //PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js